import { render, staticRenderFns } from "./ChatMessages.vue?vue&type=template&id=965fce10&scoped=true"
import script from "./ChatMessages.vue?vue&type=script&lang=js"
export * from "./ChatMessages.vue?vue&type=script&lang=js"
import style0 from "./ChatMessages.vue?vue&type=style&index=0&id=965fce10&prod&lang=css"
import style1 from "./ChatMessages.vue?vue&type=style&index=1&id=965fce10&prod&scoped=true&lang=css"
import style2 from "./ChatMessages.vue?vue&type=style&index=2&id=965fce10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../masterplan/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965fce10",
  null
  
)

export default component.exports